






































import { Component, Vue, Inject} from 'vue-property-decorator';
import iView from 'iview';
import Ajax from '../../../../lib/ajax'
import AbpBase from '../../../../lib/abpbase'
import ProjectManage from '../projectManage.vue'
@Component({
    name:'projectTime',
    components: {
        ProjectManage
    }
})
export default class ProjectTime extends AbpBase  {
    initData:any ={
        searchData: {},
        tableData: {
            title: [
                {
                    title: '项目编号',
                    key: 'projectCode',
                    align: 'center',
                    width: 150
                },
                {
                    title: '项目名称',
                    key: 'projectName',
                    minWidth: 380,
                    align: 'center',
                    render: (h:any,params:any) => {
                        return h('a',{
                            on:{
                                click: ()=> {
                                    this.ToDetail(params.row);
                                }
                            }
                        },params.row.projectName)
                    }
                },
                {
                    title: '野外施工结束时间',
                    key: 'fieldConstructionFinishDt',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        console.log(params)
                        let temp:any = [];
                        if(params.row.isFieldConstructionOverdu){
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.fieldConstructionFinishDt ? params.row.fieldConstructionFinishDt.substring(0,10).replace(/\//g, '-') : ''),
                                h('P', {style:{color:'red',border:'1px solid red',padding:'3px',borderRadius:'5px'}}, '延期')
                            ]
                        }else{
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.fieldConstructionFinishDt ? params.row.fieldConstructionFinishDt.substring(0,10).replace(/\//g, '-') : '')
                            ]
                        }
                        return h('Row', temp);
                    }
                },
                {
                    title: '野外验收时间',
                    key: 'fieldAcceptanceDt',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        let temp:any = [];
                        if(params.row.isFieldAcceptanceOverdu){
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.fieldAcceptanceDt ? params.row.fieldAcceptanceDt.substring(0,10).replace(/\//g, '-') : ''),
                                h('p', {style:{color:'red',border:'1px solid red',padding:'3px',borderRadius:'5px'}}, '延期')
                            ]
                        }else{
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.fieldAcceptanceDt ? params.row.fieldAcceptanceDt.substring(0,10).replace(/\//g, '-') : '')
                            ]
                        }
                        return h('Row', temp);
                    }
                },
                {
                    title: '报告评审备案时间',
                    key: 'reportReviewFilingDt',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        let temp:any = [];
                        if(params.row.isReportReviewFilingOverdu){
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.reportReviewFilingDt ? params.row.reportReviewFilingDt.substring(0,10).replace(/\//g, '-') : ''),
                                h('p', {style:{color:'red',border:'1px solid red',padding:'3px',borderRadius:'5px'}}, '延期')
                            ]
                        }else{
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.reportReviewFilingDt ? params.row.reportReviewFilingDt.substring(0,10).replace(/\//g, '-') : '')
                            ]
                        }
                        return h('Row', temp);
                    }
                },
                {
                    title: '资料汇交时间',
                    key: 'dataExchangeDt',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        let temp:any = [];
                        if(params.row.isDataExchangeOverdu){
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.dataExchangeDt ? params.row.dataExchangeDt.substring(0,10).replace(/\//g, '-') : ''),
                                h('p', {style:{color:'red',border:'1px solid red',padding:'3px',borderRadius:'5px'}}, '延期')
                            ]
                        }else{
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.dataExchangeDt ? params.row.dataExchangeDt.substring(0,10).replace(/\//g, '-') : '')
                            ]
                        }
                        return h('Row', temp);
                    }
                },
                {
                    title: '提交决算申请时间',
                    key: 'submitFinalAccountDt',
                    align: 'center',
                    width: 150,
                    render: (h:any, params:any)=>{
                        let temp:any = [];
                        if(params.row.isSubmitFinalAccountOverdu){
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.submitFinalAccountDt ? params.row.submitFinalAccountDt.substring(0,10).replace(/\//g, '-') : ''),
                                h('p', {style:{color:'red',border:'1px solid red',padding:'3px',borderRadius:'5px'}}, '延期')
                            ]
                        }else{
                            temp = [
                                h('Col', {props: {span: '12'}}, params.row.submitFinalAccountDt ? params.row.submitFinalAccountDt.substring(0,10).replace(/\//g, '-') : '')
                            ]
                        }
                        return h('Row', temp);
                    }
                },
                
                {
                    title: '操作',
                    key: '',
                    align: 'center',
                    width: 250,
                    render: (h:any, params:any)=>{
                        return h('div', [
                            h('Button',{
                                props:{
                                    size:'small'
                                },
                                style:{
                                    marginRight:'5px',
                                },
                                on:{
                                    click:async ()=>{
                                        this.linkTo('QualityWholeWorkload',params.row.id);
                                    }
                                }
                            },'总体工作量'),
                            h('Button',{
                                props:{
                                    size:'small'
                                },
                                style:{
                                    marginRight:'5px',
                                },
                                on:{
                                    click:async ()=>{
                                        this.linkTo('QualityProgress',params.row.id);
                                    }
                                }
                            },'项目进度')
                        ])
                    }
                }
            ],
            conttent: [],
            totalCount: 0,
            loading: true
        },
        dicData: {
            allDictionary: {},
            bearerOrg: []
        }
    }
    linkTo(type:any,id:any){
        (this as any).reloadComponent('projectDetail');
        this.$nextTick( () => {
            this.$router.push({name:'projectDetail',query:{'id':id,'currentName':type}});
        } )
    }
    //项目填报
    Add() {
        (this as any).reloadComponent('projectAdd');
        this.$nextTick( ()=>{
            this.$router.push({
                name: 'projectAdd'
            })
        } )
    }
    //详情
    ToDetail(e:any) {
        (this as any).reloadComponent('projectDetail');
        this.$nextTick( () => {    
            this.$router.push({
                name: 'projectDetail',
                query: {
                    id: e.id
                }
            })
        } ) 
    }
    //分页获取数据
    ChangePage(page:any) {
        this.initData.searchData.SkipCount = page-1;
        this.GetData()
    }
    //切换每页条数
    ChangePageNum(perPage:any){
        this.initData.searchData.MaxResultCount = perPage;
        this.GetData()
    }
    async GetData() {
        this.initData.tableData.loading = true;
        await Ajax.get('/api/services/app/ProjectManager/GetAllReverseAsync', {params: this.initData.searchData}).then((res:any)=>{
            if(res.data.result){
                this.initData.tableData.content = res.data.result.items;
                this.initData.tableData.totalCount = res.data.result.totalCount;
            }else{
                this.$Message.error('暂无数据！');
                this.initData.tableData.content = [];
                this.initData.tableData.totalCount = 0;
            }
            this.initData.tableData.loading = false;
        })
    }
    async GetDic() {
        await this.$store.dispatch({
            type:'project/GetAllDictionary'
        })
        await this.$store.dispatch({
            type:'project/GetbearerOrg'
        })
        //格式化
        this.$store.state.project.allDictionary.map((item:any) => {
            this.initData.dicData.allDictionary[item.key] = item.items.map((items:any) => {
                return {
                    label: items.displayName,
                    value: items.id
                }
            });
        })
        this.initData.dicData.bearerOrg = this.$store.state.project.bearerOrgId;
    }
    mounted() {
        this.initData.id = this.$route.query.id;
        this.GetDic();
        this.GetData();
    }
}
